/**
 * @generated SignedSource<<c85bb8d4319589d7107ce65db6b00c60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionDetailsCollapsedUi = "DESCRIPTION" | "ISSUES" | "ISSUE_ASSOCIATED_DESIGNS" | "PROGRESS_CARD" | "RELATED_WORK" | "RICH_TEXT_SECTION" | "RIGHT_SIDEBAR" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection$data = {
  readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection";
};
export type ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection$key = {
  readonly " $data"?: ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "collapsedUis"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "4c7960151ff25f69412e79192a278d0e";

export default node;
